var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"font-weight-regular"},[_vm._t("default")],2)],1),_c('v-list-item-icon',[(_vm.fulfilled)?_c('v-icon',{attrs:{"color":"green"}},[_vm._v(_vm._s(_vm.icons.mdiCheckCircle))]):_c('v-icon',{attrs:{"color":"red"}},[_vm._v(_vm._s(_vm.icons.mdiMinusCircle))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }